import React from 'react';
import classNames from "classnames";

import './LoadingHorizontal.css';

export interface LoadingHorizontalProps {
    isVisible: boolean;
}

export const LoadingHorizontal = ({isVisible}: LoadingHorizontalProps) => {
    return (
        <div
            className={classNames({
                'LoadingHorizontal': true,
                'LoadingHorizontal--visible': isVisible,
            })}
        >
            <div
                className={'LoadingHorizontal__line pm-liner-loading'}
            />
        </div>
    );
}
